import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import MUITooltip from '@material-ui/core/Tooltip';
import useCopyFeedback from 'core/hooks/use-copy-feedback';
import CopyFeedback from 'core/components/copy-feedback/copy-feedback';

import { Label } from 'core/components/label';
import copyIcon from './icCopy_24px.svg';
import useStyles from './label-with-copy-button.styles';
import { useToast } from 'core/components/toast';

const LabelWithCopyButton = ({ children, editing, type, ...props }) => {
  const formatted = children.toString().replaceAll(',', '');
  const title = `Copy ${formatted} to clipboard`;
  const classes = useStyles();
  const toast = useToast();
  const { copied, copyValue } = useCopyFeedback(formatted);

  const onClick = useCallback(() => {
    if (!copyValue()) {
      toast.notify({
        type: 'error',
        message: `${formatted} could not be copied`
      });
    }
  }, [copyValue, formatted, toast]);

  return (
    <Grid className={classes.container}>
      <MUITooltip title={title} arrow placement="top" classes={{ tooltip: classes.tooltip }}>
        <Button onClick={onClick} className={classes.button} aria-label={title}>
          <Label type={type} {...props} className={classes.label}>
            {children}
          </Label>
          <CopyFeedback copied={copied} icon={copyIcon} className={classes.icon} />
        </Button>
      </MUITooltip>
    </Grid>
  );
};

LabelWithCopyButton.propTypes = {
  children: PropTypes.node.isRequired
};

export default LabelWithCopyButton;
